import { useLocalization } from '@utils/useLocalization';
import dayjs, { type Dayjs } from 'dayjs';
import { Typography, type TypographyProps } from 'hephaestus/web';
import type { ReactElement } from 'react';

type DateProps = {
  date?: string | Dayjs | Date | null;
  isYearEnd?: boolean;
  timezone?: string;
} & Omit<TypographyProps, 'children'>;

export const Date = ({
  date: dateProp,
  isYearEnd,
  timezone,
  ...props
}: DateProps): ReactElement | null => {
  let date = dateProp;
  const { localizedDate } = useLocalization();

  if (!date) {
    return null;
  }

  if (typeof date === 'string') {
    if (isYearEnd) {
      const parsedDate = dayjs(date);
      date = `${parsedDate.format('DD-MM')}`;
    } else {
      date = date.substring(0, 10); // Drop `+HHMM` timezone part
    }
  }
  const dayjsObject = dayjs.isDayjs(date) ? date : dayjs(date);

  return (
    <Typography variant='bodySmall' component='p' {...props}>
      {isYearEnd
        ? String(date)
        : localizedDate(timezone ? dayjsObject.tz(timezone) : dayjsObject)}
    </Typography>
  );
};
